import apiUrl from '../../../../constants'
import axios from 'axios'
import Pagination from './../../shared/pagination'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
export default {
	name: 'grcLogReport',
	components: {
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			currentPage: 1,
			totalPage: 0,
			totalRows: 0,
			pageLimit: 10,
			listGoodsReceiptData: [],
			listMerchantData: [],
			listwarehouseidData: [],
			listGoodsReceiptFinalData: [],
			pono: '',
			supplier: '',
			invoiceno: '',
			fromdate: '',
			todate: '',
			ProductID: '',
			listReportDatacsv: [],
			csvFields: [],
			isLoading: false,
			formattedDate: '',
			warehouseid: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			client: '',
			warehouse: '',
			clientid:'',
			warehouseid:'',
			ClientErr: '',
			WarehouseErr: '',
			ClientErr: '',
			merchantid: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			user_type: '',
			invreferenceid: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			isLoadingforxls: false,
			limitExeed: false,
			recordLimit: 0,
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: '',
			activemrpflag:false,
		}
	},
	computed: {

	},
	mounted() {
		this.calldateFunction();
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('editedjson.grcLogReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.pageno = 0;
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getMerchantData();
        }
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				break;
			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				this.getActiveMrpFlag();
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantid = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			// if (!this.limitExeed) {
			this.getGoodsReceiptReportDataForXls(3)
			// }
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
						result.data.forEach(function (item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}
				}, error => {
					console.error(error)
				})
		},
		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantid = '';
		// 		if (this.clientid) {
		// 			this.getMerchantData();
		// 			this.item = {}
		// 			this.getActiveMrpFlag();
		// 		}
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 		}
		// 	}
		// 	this.listGoodsReceiptFinalData = [];
		// 	this.listGoodsReceiptData = [];
		// 	this.listRackinData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getMerchantData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// 	this.listGoodsReceiptData = [];
		// 	this.listGoodsReceiptFinalData = [];
		// },
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": this.clientid,
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		//to get search filter
		getGoodReceiptReportDataSearch() {
			this.currentPage = 1;
			this.pageCount = 0;
			this.searchFlag = true;
			this.getGoodsReceiptReportData(2);
		},
		//to get goods receipt list
		getGoodsReceiptReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.pageCount = 0;
				this.listGoodsReceiptFinalData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.pageCount = 0;
				this.listGoodsReceiptFinalData = [];
				return false;
			}
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			var fr_date = '';
			var to_date = '';
			var i = 0;
			var tempClientarray = [];
			var tempfinalArray = [];
			if (this.fromdate) {
				fr_date = this.dateFormat(this.fromdate)
			}
			this.isLoading = true;
			if (this.todate) {
				to_date = this.dateFormat(this.todate)
			} else {
				to_date = this.dateFormat(this.todate)
			}
			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromddate: this.dateFormat1(fr_date),
				todate: this.dateFormat2(to_date),
				invoiceno: this.invoiceno.trim(),
				pono: this.pono.trim(),
				invreferenceid: this.invreferenceid.trim(),
				csvData: csvCheck,
				productid: this.ProductID.trim(),
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchantid,
				userid: this.userid,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'grcLogReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.listReportDatacsv = [];
							this.show = true;
							this.download = false;
							this.csvFields = {
								'pono': this.$t('removeHold.poId'),
								'merchantname': this.$t('warehouseRacks.merchant'),
								'invoiceno': this.$t('inwardList.invoiceId'),
								'invreferenceid': this.$t('removeHold.drId'),
								'productid': this.$t('common.productId'),
								'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
								'mrp': this.$t('printProductDetails.mrp'),
								'activemrp': this.$t('common.activemrp'),
								'productname': this.$t('printProductDetails.productName'),
								'brand': this.$t('common.brand'),
								'productcategory': this.$t('common.productCategory'),
								'productsubcategory': this.$t('product.productSubCategory'),
								'polineno':  this.$t('removeHold.poLineNumber'),
								'quantity': this.$t('removeHold.poLineQty'),
								'orderedquantity': this.$t('removeHold.invoiceLineQty'),
								'totalreceivequantity':  this.$t('removeHold.totalReceivedQty'),
								'totalacceptedqty': this.$t('removeHold.totalAcceptedQty'),
								'grcrejectqty': this.$t('removeHold.totalRejectedQty'),
								'storeinquantity': this.$t('editedjson.storeInQuantity'),
								'rejectstoreinquantity': this.$t('editedjson.rejectedStoreInQuantity'),
								'drdatetime': this.$t('removeHold.drDatetime'),
								'grndatetime': this.$t('removeHold.grnDatetime'),
								'grcdoneby': this.$t('removeHold.grnDoneby'),
								'nooflots':  this.$t('removeHold.noOfLots')
							};
							var dateFilter = [];
							if(this.activemrpflag === true){
								var skipFilter = ['count', 'clientid', 'grcno', 'merchantid'];
							}else {
								var skipFilter = ['count', 'clientid', 'grcno', 'merchantid','activemrp'];
							}
							for (i = 0; i < this.listMerchantData.length; i++) {
								tempClientarray[this.listMerchantData[i].merchantid] = this.listMerchantData[i].merchantname;
							}
							for (i = 0; i < result.data.data.length; i++) {
								tempfinalArray = [];
								tempfinalArray = result.data.data[i];
								if (!result.data.data[i].merchantid) {
									tempfinalArray["merchantid"] = '';
								} else {
									tempfinalArray["merchantid"] = tempClientarray[result.data.data[i].merchantid];
								}
								this.listReportDatacsv.push(tempfinalArray);
							}
							csvHelper.data.jsonToCSV(this.$t('editedjson.grcLogReport'), this.listReportDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listGoodsReceiptFinalData = [];
						this.listGoodsReceiptData = result.data.data
						for (i = 0; i < this.listMerchantData.length; i++) {
							tempClientarray[this.listMerchantData[i].merchantid] = this.listMerchantData[i].merchantname;
						}
						for (i = 0; i < this.listGoodsReceiptData.length; i++) {
							tempfinalArray = [];
							tempfinalArray = this.listGoodsReceiptData[i];

							if (this.listGoodsReceiptData[i].merchantid == "") {
								tempfinalArray["merchantid"] = '';
							} else {
								tempfinalArray["merchantid"] = tempClientarray[this.listGoodsReceiptData[i].merchantid];
							}
							this.listGoodsReceiptFinalData.push(tempfinalArray);
						}
						if (result.data.errorCode == -1) {
							this.resultCount = 0
							this.totalRows = 0;
						} else {
							this.totalRows = Number(result.data.count)
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		getGoodsReceiptReportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			var fr_date = '';
			var to_date = '';
			var i = 0;
			var tempClientarray = [];
			var tempfinalArray = [];
			if (this.fromdate) {
				fr_date = this.dateFormat(this.fromdate)
			}
			if (this.todate) {
				to_date = this.dateFormat(this.todate)
			} else {
				to_date = this.dateFormat(this.todate)
			}
			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromddate: this.dateFormat1(fr_date),
				todate: this.dateFormat2(to_date),
				invoiceno: this.invoiceno.trim(),
				pono: this.pono.trim(),
				invreferenceid: this.invreferenceid.trim(),
				csvData: csvCheck,
				productid: this.ProductID.trim(),
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchantid,
				userid: this.userid,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'grcLogReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('removeHold.poId')] =  'pono';
							this.csvFieldsForXls[this.$t('warehouseRacks.merchant')] = 'merchantname';
							this.csvFieldsForXls[this.$t('inwardList.invoiceId')] = 'invoiceno';
							this.csvFieldsForXls[this.$t('removeHold.drId')] = 'invreferenceid';
							this.csvFieldsForXls[this.$t('common.productId')] = 'productid';
							this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('printProductDetails.mrp')] = 'mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')] = 'activemrp';
							}
							this.csvFieldsForXls[this.$t('printProductDetails.productName')] ='productname';
							this.csvFieldsForXls[this.$t('common.brand')] = 'brand';
							this.csvFieldsForXls[this.$t('common.productCategory')] = 'productcategory';
							this.csvFieldsForXls[this.$t('product.productSubCategory')] =  'productsubcategory';
							this.csvFieldsForXls[this.$t('removeHold.poLineNumber')] =  'polineno';
							this.csvFieldsForXls[this.$t('removeHold.poLineQty')] =  'quantity';
							this.csvFieldsForXls[this.$t('removeHold.invoiceLineQty')] =  'orderedquantity';
							this.csvFieldsForXls[this.$t('removeHold.totalReceivedQty')] =  'totalreceivequantity';
							this.csvFieldsForXls[this.$t('removeHold.totalAcceptedQty')] = 'totalacceptedqty';
							this.csvFieldsForXls[this.$t('removeHold.totalRejectedQty')] = 'grcrejectqty';
							this.csvFieldsForXls[this.$t('editedjson.storeInQuantity')] = 'storeinquantity';
							this.csvFieldsForXls[this.$t('editedjson.rejectedStoreInQuantity')] = 'rejectstoreinquantity';
							this.csvFieldsForXls[this.$t('removeHold.drDatetime')] = 'drdatetime';
							this.csvFieldsForXls[this.$t('removeHold.grnDatetime')] =  'grndatetime';
							this.csvFieldsForXls[this.$t('removeHold.grnDoneby')] = 'grcdoneby';
							this.csvFieldsForXls[this.$t('removeHold.noOfLots')] = 'nooflots';

							for (i = 0; i < this.listMerchantData.length; i++) {
								tempClientarray[this.listMerchantData[i].merchantid] = this.listMerchantData[i].merchantname;
							}
							for (i = 0; i < result.data.data.length; i++) {
								tempfinalArray = [];
								tempfinalArray = result.data.data[i];
								if (!result.data.data[i].merchantid) {
									tempfinalArray["merchantid"] = '';
								} else {
									tempfinalArray["merchantid"] = tempClientarray[result.data.data[i].merchantid];
								}
								this.listReportDataforxls.push(tempfinalArray);
							}
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
				}, error => {
					console.error(error)
				})
		},

		onPageChange(page) {
			this.currentPage = page;
			this.getGoodsReceiptReportData()
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},

		//to reset search form
		resetSearchForm() {
			this.item = {}
			this.show = false;
			this.download = true;
			this.fromdate = '';
			this.todate = '';
			this.invoiceno = '';
			this.pono = '';
			this.supplier = '';
			this.ProductID = '';
			this.merchantid = '';
			this.totalRows = 0;
			this.searchFlag = false;
			this.invreferenceid = '';
			this.listGoodsReceiptFinalData = [];
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
		//validate all form fields on onsubmit()
		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/grcLogReport/grcLogReport.component.js